module.exports = __webpack_public_path__ + "static/halberd_fighter-0db24701622b5afea4a57aa604c71001.jpg";